import { HubConnectionState } from '@microsoft/signalr';
import { SignalRHubType } from '@mti/multitenant-ui-shared';

/* --- STATE --- */
export interface HeaderState {
  signalRHubStatuses: HubStatusesType;
}

export enum AdditionalHubConnectionState {
  Uninitialised = 'Uninitialised',
  Failure = 'Failure',
}

export type HubStatusesType = {
  [key in SignalRHubType]: HubStatus;
};

export interface HubStatus {
  hubType: SignalRHubType;
  status: HubConnectionState | AdditionalHubConnectionState;
  // We track this so we can ignore the first disconnect event which happens on hub initialisation
  disconnectCount: number;
}

export interface LogoutRequest {
  tenantId: string;
  operatorId: string;
  accessToken: string;
}

export enum ThemeType {
  LIGHT = 'light',
  DARK = 'dark',
}

export enum TabType {
  Book,
  Dispatch,
  Map,
  Admin = 99,
}

export enum FrontendName {
  Telop = 'TelOp',
  Supervisor = 'Supervisor',
  Query = 'QueryPortal',
  Messaging = 'Messaging',
  Map = 'Map',
}

export type ContainerState = HeaderState;
